import styled from 'styled-components';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Divider = styled.hr`
  height: 1px;
  border: 0;
  background-color: ${token('color.border', colors.N30A)};
  margin: ${token('space.100', '8px')} 0;
`;

export const OnMergeDescription = styled.div`
  font-weight: 700;
  font-size: 11px;
  color: ${token('color.text.subtle', colors.N800)};
  margin-top: ${token('space.100', '8px')};
`;
